import React from 'react';
import { Icon } from './Icon.js';
export const IconFollowObjUpLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M12.061,11h2.7c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75h-4.511c-.414,0-.75,.336-.75,.75v4.51c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-2.7l3.72,3.72c.146,.146,.338,.22,.53,.22s.384-.073,.53-.22c.293-.293,.293-.768,0-1.061l-3.72-3.72Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "2", width: "7", height: "7", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconFollowObjUpLeftFill18.js.map